import {
  Component,
  Input,
  HostListener,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { UploadFile, UploadStatusNome } from "./upload-file";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ProcessoService } from "@app/services/processo.service";
import { ProcessoAnexo } from "@app/models/processo-anexo.model";
import { ToastrService } from "ngx-toastr";
import { ModalConfirmarComponent } from "@app/components/modal-confirmar/modal-confirmar.component";
import {
  BlobServiceClient,
  BlobUploadCommonResponse,
  BlockBlobUploadOptions,
  ContainerClient,
} from "@azure/storage-blob";
import { from, Observable, of, throwError } from "rxjs";
import { map, catchError, switchMap } from "rxjs/operators";
import { UploadFileSasUrl } from "@app/models/upload-file-sas-url";

@Component({
  selector: "app-upload-file",
  templateUrl: "./upload-file.component.html",
  styleUrls: ["./upload-file.component.scss"],
})
export class UploadFileComponent {
  
  lstProcessoAnexo: Array<ProcessoAnexo> = [];

  @Input() fileList: Array<UploadFile> = [];
  @Input() processoId: number;
  @Input() aparecerEditar: boolean = false;
  @Input() lstProcessoAnexoSelecionados: Array<ProcessoAnexo> = [];
  @Input() arquivosConcluidos: Array<UploadStatusNome> = [];
  @Input() tentativas = 0;
  @Input() mostrarTipoUpload: boolean = true;
  @Input() arquivosMenores20MB: boolean = true;

  public uploadProgress: number;
  public carregandoDocumentos: boolean;
  public bsModalRef: BsModalRef;

  get exibrAreaDeUpload(): boolean {
    return this.arquivosMenores20MB || this.fileList.length === 0;
  }

  get textoAreaDeUpload(): string {
    const termo = this.arquivosMenores20MB ? "os arquivos" : "o arquivo";
    return `Solte ${termo} ou clique para carregar`;
  }

  @ViewChild("modalDocumentos", { static: true })
  modalDocumentos: TemplateRef<any>;

  @HostListener("dragover", ["$event"]) onDragOver(event) {
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event) {
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event) {
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event) {
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer.files;
    this.saveFiles(files);
  }

  @Output() limparListaArquivos = new EventEmitter();

  constructor(
    private processoService: ProcessoService,
    public modalService: BsModalService,
    private toastrService: ToastrService
  ) {}

  onFileChange(event) {
    const files = event.target.files;
    this.saveFiles(files);
  }

  saveFiles(files: FileList) {
    if(this.arquivosMenores20MB){
      if(files.length > 0){
        for (let j = 0; j < files.length; j++) {
          const arquivo = new UploadFile();
          arquivo.File = files[j];
          if (arquivo.File.size > 20971520) {
            this.toastrService.error(arquivo.File.name, "Arquivo maior que 20MB");
            return;
          }
          arquivo.Descricao = arquivo.File.name.split('.').slice(0, -1).join('.');
          this.fileList.push(arquivo);
        }
      }
    }

    if (this.arquivosMenores20MB === false && this.fileList.length < 1){
      if (files.length <= 1){
        const arquivo = new UploadFile();
        arquivo.File = files[0];

        if (arquivo.File.size > 1 * 1024 * 1024 * 1024) {
          this.toastrService.error(arquivo.File.name, "Tamanho máximo é 1GB");
          return;
        }

        arquivo.Descricao = arquivo.File.name.split('.').slice(0, -1).join('.');
        this.fileList.push(arquivo);

      }
    }
    
    if(!this.arquivosMenores20MB && this.fileList.length > 1)
      this.toastrService.info("É permitido um único upload por gravação.", "Arquivos Grandes!");
  }

  uploadArquivoGrande(arquivo: UploadFile): Promise<void> {
    if (arquivo.File.size > 1 * 1024 * 1024 * 1024) {
      this.toastrService.error(arquivo.File.name, "Tamanho de Arquivo superior a 1 GB");
      return Promise.reject("Tamanho de Arquivo superior a 1 GB");
    }

    if (arquivo.File.size <= 20 * 1024 * 1024) {
      this.toastrService.error(arquivo.File.name, "Tamanho de arquivo inferior a 20MB");
      return Promise.reject("Tamanho de arquivo inferior a 20MB");
    }


    const fileNameArray = arquivo.File.name.split(".");
    if (fileNameArray.length < 2 || fileNameArray[fileNameArray.length - 1] === "") {
      this.toastrService.error(arquivo.File.name, "Arquivo sem extensão válida!");
      return Promise.reject("Arquivo sem extensão válida!");
    }

    const processoDocumento = {
      Id: 0,
      ProcessoId: this.processoId,
      ArquivoNome: arquivo.File.name,
      Descricao: arquivo.Descricao,
      Extensao: fileNameArray[fileNameArray.length - 1],
      UsuarioId: 1,
      Subcategoria: "",
      SubcategoriaId: 1,
      TipoDocumentoId: 1,
      SomenteDesdeProcesso: false,
    };

    return this.AdicionandoArquivoViaSasNoStorage(processoDocumento, arquivo)
      .then(() => {
        this.toastrService.success("Upload concluído com sucesso!");
        arquivo.progress = 100;

        this.arquivosConcluidos.push({
          status: true,
          nomeArquivo: arquivo.Descricao,
        });
      })
      .catch((error) => {
        console.error("Erro no upload:", error);

        this.arquivosConcluidos.push({
          status: false,
          nomeArquivo: arquivo.Descricao,
        });
        throw error;
      });
  }

  uploadArquivoPequeno(arquivo: UploadFile): Promise<void> {
    const fileNameArray = arquivo.File.name.split(".");
    if (fileNameArray.length < 2 || fileNameArray[fileNameArray.length - 1] === "") {
      this.toastrService.error(arquivo.File.name, "Arquivo sem extensão válida!");
      return Promise.reject("Arquivo sem extensão válida!");
    }

    const processoDocumento = {
      Id: 0,
      ProcessoId: this.processoId,
      ArquivoNome: arquivo.File.name,
      Descricao: arquivo.Descricao,
      Extensao: fileNameArray[fileNameArray.length - 1],
      UsuarioId: 1,
      Subcategoria: "",
      SubcategoriaId: 1,
      TipoDocumentoId: 1,
      SomenteDesdeProcesso: false,
    };

    return this.AdicionandoArquivoViaSasNoStorage(processoDocumento, arquivo)
      .then(() => {
        this.toastrService.success("Upload concluído com sucesso!");
        arquivo.progress = 100;

        this.arquivosConcluidos.push({
          status: true,
          nomeArquivo: arquivo.Descricao,
        });
      })
      .catch((error) => {
        console.error("Erro no upload:", error);

        this.arquivosConcluidos.push({
          status: false,
          nomeArquivo: arquivo.Descricao,
        });
        throw error;
      });
  }

  AdicionandoArquivoViaSasNoStorage(
    processoDocumento: any,
    arquivoFile: UploadFile
  ): Promise<void> {
    return this.processoService.gravarObtendoSas(
      processoDocumento,
      "documentos"
    )
      .pipe(
        switchMap((uploadFileSasUrl) =>
          this.enviaArquivoParaStorage(uploadFileSasUrl, arquivoFile).pipe(
            map(() => this.extrairIdAnexo(uploadFileSasUrl.NomeArquivo))
          )
        ),
        switchMap((idAnexo) => this.verificarUpload(idAnexo, arquivoFile)),
        catchError((error) => {
          const mensagem =
            error?.error?.errors?.[0] ??
            error?.message ??
            "Erro ao realizar o upload do arquivo.";
          this.toastrService.error(mensagem);
          return throwError(error);
        })
      )
      .toPromise();
  }

  enviaArquivoParaStorage(uploadFileSasUrl: UploadFileSasUrl, arquivoFile: UploadFile): Observable<BlobUploadCommonResponse> {
    const blobService = new BlobServiceClient(
      uploadFileSasUrl.SasUrlUpload
    );
    const containerClient: ContainerClient = blobService.getContainerClient(
      ""
    );
    const blobClient = containerClient.getBlockBlobClient(
      uploadFileSasUrl.NomeArquivo
    );

    const onProgress = (ev: any) => {
      arquivoFile.progress = Math.round(
        (ev.loadedBytes / arquivoFile.File.size) * 100
      );
    };

    if (arquivoFile.File.size > 20 * 1024 * 1024) {
      return from(
        blobClient.uploadData(arquivoFile.File, {
          blockSize: 4 * 1024 * 1024,
          concurrency: 20,
          onProgress,
          blobHTTPHeaders: {
            blobContentType: arquivoFile.File.type,
          },
        })
      );
    }

    const options: BlockBlobUploadOptions = {
      onProgress,
      blobHTTPHeaders: {
        blobContentType: arquivoFile.File.type,
      },
    };
    return from(
      blobClient.upload(
        arquivoFile.File,
        arquivoFile.File.size,
        options
      )
    );
  }

  iniciarUpload() {
    if (this.fileList.length === 0) {
      this.toastrService.warning("Nenhum arquivo para upload.");
      return;
    }

    let contadorSucesso = 0;

    this.fileList.forEach((arquivo) => {
      if (this.arquivosMenores20MB) {
        this.uploadArquivoPequeno(arquivo);
      } else {
        this.uploadArquivoGrande(arquivo);
      }
    });
  }

  modificaFluxoArquivo(enviarArquivoPequeno: boolean): void {
    if(enviarArquivoPequeno === this.arquivosMenores20MB) return; //Usuario clicou na opção já ativa, nao fazer nada

    if(this.fileList.length === 0) {
      this.arquivosMenores20MB = !this.arquivosMenores20MB;
      return;
    }

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = `Deseja realmente mudar a opção de upload de arquivos ?
    Todos os arquivos inseridos serão deletados !`
    this.bsModalRef.content.confirmar = () => {
      this.arquivosMenores20MB = !this.arquivosMenores20MB;
      this.fileList = [];
    };

  }

  calculaTamanho(tamanho: number) {
    return this.formatFileSize(tamanho, 1);
  }

  formatFileSize(bytes: number, decimalPoint: number) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimalPoint || 2;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    );
  }

  deletar(i: number) {
    this.fileList.splice(i, 1);
  }

  abrirModal() {
    this.modalService.show(this.modalDocumentos);
    this.carregandoDocumentos = true;
    this.lstProcessoAnexo = [];
    this.processoService
      .obterDocumentos(this.processoId)
      .toPromise()
      .then((data: Array<ProcessoAnexo>) => {
        this.lstProcessoAnexo = data;
        this.carregandoDocumentos = false;
      });
  }

  selecionarDocumentos() {
    this.lstProcessoAnexoSelecionados.push(...this.lstProcessoAnexo.filter(x => x.Selecionado));
    this.modalService.hide(1);
  }

  deletarDocunmento(i: number) {
    this.lstProcessoAnexoSelecionados.splice(i, 1);
  }

  avisoFuncionalidadeInativa() {
    this.toastrService.warning("Funcionalidade desativada!");
  }

  onSubmit() {
    if (this.arquivosMenores20MB) {
      this.iniciarUpload();
    } else {
      this.iniciarUpload();
    }
  }

  private verificarUpload(idAnexo: number, upload: UploadFile): Observable<void> {
    return this.processoService.verificaExistenciaArquivoMovimentacao(idAnexo, "proanexo").pipe(
      switchMap(existenciaArquivo => {
        if (existenciaArquivo) {
          upload.progress = 100;
          return of(void 0);
        }

        throw new Error("Erro ao verificar upload.");
      }),
      catchError(error => {
        return this.processoService.movimentacaoDeletarArquivo(idAnexo).pipe(
          map(() => {
            throw error;
          }),
          catchError(() => {
            throw error;
          })
        );
      })
    );
  }

  private extrairIdAnexo(nomeArquivo: string): number {
    const idString = nomeArquivo.replace(/([A-z]+)\_(\d+)\.([A-z0-9]+)/, "$2");
    return Number.parseInt(idString, 10);
  }
}
